import { ViewEncapsulation } from '@angular/core';
import { EnvironmentEnum, EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  apiUrl: 'https://s2atesting.amersports.com/api',
  env: EnvironmentEnum.production,
  production: true,
  defaultEncapsulation: ViewEncapsulation.None,
};
